import configRoutes from 'config/routes'

type CheckoutError = {
  match: (message: string) => boolean
  errorCode: string
  errorTitle: string
  errorMessage: string
  actionLabel: string
  retryFunc: () => void
}

export const checkoutErrors: CheckoutError[] = [
  {
    match: (msg) => msg === 'basket-expired',
    errorCode: 'checkout-basket-expired',
    errorTitle: 'Uh oh, something went wrong',
    errorMessage: 'Sorry, your box has expired. Please re-add your recipe choices to continue.',
    actionLabel: 'Choose recipes again',
    retryFunc: () => window.location.reload(),
  },
  {
    match: (msg) =>
      msg.includes('not available for the order period') || msg.includes('recipes are sold-out'),
    errorCode: 'checkout-out-of-stock',
    errorTitle: 'Some of your recipes just sold out',
    errorMessage:
      "Sorry, this was caused by a rare issue on our side. We're already working to improve the experience as quickly as we can. Please choose your recipes again to complete your order.",
    actionLabel: 'Choose recipes again',
    retryFunc: () => window.location.reload(),
  },
  {
    match: (msg) => msg.includes('having the same delivery date'),
    errorCode: 'checkout-conflicting-order',
    errorTitle: 'You already have a box scheduled for this date',
    errorMessage:
      "To make changes, please edit your existing box instead. We're sorry - normally, we'd flag this before you chose your recipes, but there was an error on our side. We're already working to fix the issue.",
    actionLabel: 'Go to Upcoming Deliveries',
    retryFunc: () => window.location.assign(configRoutes.client.myDeliveries),
  },
  {
    match: (msg) => msg.includes('day and slot combination is not available'),
    errorCode: 'checkout-day-slot-combination-unavailable',
    errorTitle: 'The day and slot combination is no longer available',
    errorMessage: 'Please select a different delivery day or slot.',
    actionLabel: 'Change now',
    retryFunc: () => window.location.assign(configRoutes.client.deliveryDetails),
  },
  {
    match: (msg) => msg.includes('account is on hold'),
    errorCode: 'checkout-account-on-hold',
    errorTitle: "We can't place your order because your account is on hold",
    errorMessage: 'To find out why and what to do next, please go to the Account Details page.',
    actionLabel: 'Go to Account Details',
    retryFunc: () => window.location.assign(configRoutes.client.myDetails),
  },
  {
    match: (msg) => msg.includes('cannot edit an order'),
    errorCode: 'checkout-order-not-editable',
    errorTitle: 'Sorry, you can no longer make changes',
    errorMessage:
      "Since your order is already being prepared, you can't make any changes or updates to it anymore.",
    actionLabel: 'Go to Upcoming Deliveries',
    retryFunc: () => window.location.assign(configRoutes.client.myDeliveries),
  },
]

export const defaultCheckoutError = {
  errorCode: 'checkout-unknown-error',
  errorTitle: 'Uh oh, something went wrong',
  errorMessage:
    'There was an issue when confirming your order. Head to your account to check your upcoming deliveries.',
  actionLabel: 'Go to Upcoming Deliveries',
  retryFunc: () => window.location.assign(configRoutes.client.myDeliveries),
}
